/* Ported from reference/salesfix-value-map-builder.html (class names in camelCase). The reference is the visual spec; edit here, not there. */
.prioritise {
  padding: 30px 34px 90px;
}
.pWrap {
  max-width: 1100px;
  margin: 0 auto;
}
.pHead {
  margin-bottom: 20px;
}
.pHead h1 {
  font-size: 28px;
  margin-top: 2px;
}
.pIntro {
  color: var(--muted);
  font-size: 14.5px;
  max-width: 700px;
  margin: 9px 0 0;
  line-height: 1.5;
}
.pTop {
  display: grid;
  grid-template-columns: 1.15fr 0.85fr;
  gap: 22px;
  align-items: start;
  margin-bottom: 30px;
}
.pMatrix {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 16px;
  box-shadow: var(--shadow);
}
.pMatrix svg {
  width: 100%;
  height: auto;
  display: block;
}
.pRank {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 16px 18px;
  box-shadow: var(--shadow);
}
.pRank h3 {
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--muted);
  margin-bottom: 12px;
}
.pRank ol {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.pRank li {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 9px 10px;
  border: 1px solid var(--border);
  border-radius: 10px;
}
.pRank .r {
  flex: 0 0 24px;
  height: 24px;
  border-radius: 6px;
  font-weight: 900;
  font-size: 12px;
  display: grid;
  place-items: center;
}
.pRank .nm {
  flex: 1;
  font-weight: 700;
  color: var(--ink);
  font-size: 14px;
  overflow: hidden;
}
.pRank .nm small {
  display: block;
  font-weight: 400;
  color: var(--muted);
  font-size: 12px;
  margin-top: 1px;
}
.pTier {
  font-size: 11px;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: 999px;
  white-space: nowrap;
  flex: 0 0 auto;
}
.pTier.quick {
  background: #eff8f1;
  color: var(--green-text);
}
.pTier.bet {
  background: #e8f3f8;
  color: var(--blue-text);
}
.pTier.fill {
  background: var(--bg);
  color: var(--muted);
}
.pTier.recon {
  background: #fdf4e7;
  color: var(--amber-text);
}
.pSub {
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--muted);
  margin: 0 0 12px;
}
.pRate {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(330px, 1fr));
  gap: 14px;
}
.pCard {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 15px 16px;
  box-shadow: var(--shadow);
}
.pCardHead {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}
.pCardHead .pNum {
  flex: 0 0 24px;
  height: 24px;
  border-radius: 6px;
  color: #fff;
  font-weight: 900;
  font-size: 12px;
  display: grid;
  place-items: center;
}
.pCardHead h3 {
  flex: 1;
  font-size: 15.5px;
}
.pScore {
  font-size: 12px;
  font-weight: 700;
  color: var(--muted);
  white-space: nowrap;
}
.pFactors {
  display: flex;
  flex-direction: column;
  gap: 9px;
}
.pFactor {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  font-size: 13px;
  font-weight: 700;
  color: var(--body);
}
.pFactor select {
  font-family: inherit;
  font-size: 13px;
  padding: 6px 9px;
  border: 1px solid var(--border-strong);
  border-radius: 7px;
  background: #fff;
  color: var(--ink);
}
.pEmptyNote {
  color: var(--muted);
  font-style: italic;
  text-align: center;
  padding: 40px;
}
.pFactor input.pFname {
  flex: 1;
  min-width: 0;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  color: var(--ink);
  border: none;
  border-bottom: 1px solid var(--border);
  background: transparent;
  padding: 4px 2px;
}
.pFactor input.pFname:focus {
  outline: none;
  border-bottom-color: var(--green-l);
}
.pFactor input.pFname::placeholder {
  color: var(--border-strong);
}
.pFactor .pFxRm {
  border: none;
  background: transparent;
  color: var(--muted);
  font-weight: 700;
  font-size: 11px;
  cursor: pointer;
  flex: 0 0 auto;
}
.pFactor .pFxRm:hover {
  color: #c0392b;
}
.pAddFactor {
  border: 1px dashed var(--border-strong);
  background: transparent;
  color: var(--blue-text);
  font-weight: 700;
  font-size: 12.5px;
  padding: 7px 12px;
  border-radius: 8px;
  cursor: pointer;
  align-self: flex-start;
}
.pAddFactor:hover {
  background: #f3fafc;
  border-color: var(--blue-l);
}
@media (max-width: 820px) {
  .pTop {
    grid-template-columns: 1fr;
  }
}
